// extracted by mini-css-extract-plugin
module.exports = {"container":"Socials_container__4isev","wrapper":"Socials_wrapper__dQjSm"};